import React from 'react';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- replace with crystal-ui
import { Dialog, DialogTitle, DialogContent, DialogActions, makeStyles } from '@applyboard/ui-components';
import CloseButtonCore from "../CloseButton/CloseButtonCore";
var useStyles = makeStyles({
  dialogActions: {
    '&.MuiDialogActions-root': {
      padding: '0',
      display: 'inline-block'
    }
  }
});
var DialogWithCloseButton = function DialogWithCloseButton(props) {
  var dialogContent = props.dialogContent,
    dialogActions = props.dialogActions,
    open = props.open,
    onClose = props.onClose;
  var classes = useStyles();
  return /*#__PURE__*/React.createElement(Dialog, {
    PaperProps: {
      style: {
        borderRadius: 8
      }
    },
    open: open,
    onClose: onClose
  }, /*#__PURE__*/React.createElement(DialogTitle, null, /*#__PURE__*/React.createElement(CloseButtonCore, {
    onClick: onClose
  })), /*#__PURE__*/React.createElement(DialogContent, null, dialogContent), /*#__PURE__*/React.createElement(DialogActions, {
    className: classes.dialogActions
  }, dialogActions));
};
export default DialogWithCloseButton;